import React, { useEffect, useState } from 'react'
import { Suspense } from 'react'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import 'swiper/components/pagination/pagination.scss'
import 'swiper/components/scrollbar/scrollbar.scss'
import withMenu from '../../hoc/withMenu'
import withSelectedMenu from '../../hoc/withSelectedMenu'
import { OrderingProvider } from '../../context/OrderingContext'
import CartDrawer from '../CartDrawer/CartDrawer'
import backimg from '../../images/foodi-footer.png'
import { store } from '../../store-redux/connect/store'
import styles from './MenuWrapper.module.scss'
import useInterval from '../../hoc/useInterval'
import general from '../../helpers/general'
import IncomingMenus from '../Alerts/IncomingMenus'
import IKImageWrapper from '../../components/IKImageWrapper'
import MenuIntroCard from '../MenuIntroCard'

function MenuWrapper(props) {
	const { selectedMenu, setSelectedMenu } = props
	const [LazyLoadedTemplate, setLazyLoadedTemplate] = useState(null)
	const { Menu, Auth } = store.getState()
	const [notifyMenus, setNotifyMenus] = useState(null)

	const orderPayBlockedBanner =
		props.isOrderRoute &&
		props.customerOrderingScopes &&
		!props.customerOrderingScopes.hasOrderingScopes &&
		props.customerOrderingScopes.checkoutBlockedReason ? (
			<div className={styles.orderPayBlockedBanner} role="status">
				{props.customerOrderingScopes.checkoutBlockedReason}
			</div>
		) : null

	const delay = 30000
	const interval = useInterval(checkClosestMenu, delay)

	function checkClosestMenu() {
		const menus = props?.data?.menus
		const notifyMenus = general?.findClosestMenus(props?.menusTimeline, menus, props?.data?.menu_period_transition)
		if (notifyMenus?.length > 0) {
			interval?.reset()
			setNotifyMenus(notifyMenus)
		}
	}

	useEffect(() => {
		if (!selectedMenu?._id) {
			setLazyLoadedTemplate(null)
			return
		}

		let template = 'Classic Template'
		if (selectedMenu?.selectedTemplate && selectedMenu?.selectedTemplate !== 'undefined') {
			template = selectedMenu.selectedTemplate
		}

		setLazyLoadedTemplate(React.lazy(() => import(`../../Templates/${template}/Menu`)))
		// eslint-disable-next-line
	}, [selectedMenu])

	const onCloseIncomingMenu = () => {
		setNotifyMenus([])
		interval?.start()
	}

	const onSwitchIncomingMenu = async () => {
		if (notifyMenus?.length === 1) {
			const menu = notifyMenus?.[0]
			if (menu && typeof menu === 'object') {
				const response = await props?.getCustomerMenu(props?.data?._id)
				if (response?.message?.restaurant?.menus?.length) {
					const toAddMenu = response?.message?.restaurant?.menus?.find(
						(mn) => mn?._id?.toString() === menu?._id?.toString()
					)
					setTimeout(() => {
						setSelectedMenu(toAddMenu)
					}, 500)
				}
			}
		} else {
			await props?.getCustomerMenu(props?.data?._id)
			setSelectedMenu(null)
		}
		setNotifyMenus([])
		interval?.start()
	}

	const selectIntroMenu = (menu) => {
		setSelectedMenu(menu)
		window.scrollTo({ top: 0, behavior: 'smooth' })
		if (Auth?.LOGGED_IN()) {
			Menu?.setMenuSelectedLocally(menu)
			localStorage.setItem('menuSelected', JSON.stringify(menu))
		}
	}

	const content =
		props?.data?.menus?.length > 1 && !selectedMenu ? (
			<>
				<div className={styles.introPage}>
					{orderPayBlockedBanner}
					{notifyMenus && notifyMenus?.length > 0 && (
						<IncomingMenus
							currentMenu={selectedMenu}
							menus={notifyMenus}
							minutes={props?.data?.menu_period_transition}
							onClose={onCloseIncomingMenu}
							onSwitch={onSwitchIncomingMenu}
						/>
					)}
					<div className={styles.introHeader}>
						{props?.data?.logo ? (
							<IKImageWrapper
								image={props?.data?.logo}
								transformation={[{ width: 300 }]}
								loading="lazy"
								lqip={{ active: true }}
								alt={props?.data?.name}
								className={styles.restaurantLogo}
							/>
						) : (
							<img className={styles.restaurantLogo} src={backimg} alt={props?.data?.name} />
						)}
						<div className={styles.menuDescription}>{props?.data?.description}</div>
						<h5>Choose a menu:</h5>
					</div>
					<div className={styles.multipleMenus}>
						{props?.data?.menus?.map((menu) => (
							<MenuIntroCard key={menu?._id} menu={menu} onSelect={selectIntroMenu} />
						))}
						{props?.data?.parentRestaurant?.menus?.map((menu) => (
							<MenuIntroCard key={menu?._id} menu={menu} onSelect={selectIntroMenu} />
						))}
					</div>
				</div>
			</>
		) : (
			<>
				{LazyLoadedTemplate && (
					<Suspense fallback={<></>}>
						{orderPayBlockedBanner}
						{notifyMenus && notifyMenus?.length > 0 && (
							<IncomingMenus
								currentMenu={selectedMenu}
								menus={notifyMenus}
								minutes={props?.data?.menu_period_transition}
								onClose={onCloseIncomingMenu}
								onSwitch={onSwitchIncomingMenu}
							/>
						)}
						<LazyLoadedTemplate {...props} />
					</Suspense>
				)}
			</>
		)

	return props.isOrderRoute ? (
		<OrderingProvider restaurantId={props?.data?._id}>
			{content}
			<CartDrawer />
		</OrderingProvider>
	) : content
}

export { MenuWrapper }

export default withMenu(withSelectedMenu(MenuWrapper))
